import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { enableItemFromSerendipity, disableItemFromSerendipity } from 'modules/serendipity/actions';
import { getUserNarrativeThinkChats } from 'modules/think-seeds/actions';
import { getUserNarrativeSpeedDatingActualCalls } from 'routes/Narratives/modules/';
import Call4Impact from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.call4Impact || {},
    thinkChats: state.thinkChats,
    speedDatingCalls: state.narratives.speedDatingCalls,
    itemsPreferencesFromSerendipity: state.serendipity.preferences,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserNarrativeThinkChats: bindActionCreators(getUserNarrativeThinkChats, dispatch),
    getUserNarrativeSpeedDatingActualCalls: bindActionCreators(getUserNarrativeSpeedDatingActualCalls, dispatch),
    enableItemFromSerendipity: bindActionCreators(enableItemFromSerendipity, dispatch),
    disableItemFromSerendipity: bindActionCreators(disableItemFromSerendipity, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Call4Impact));



// WEBPACK FOOTER //
// ./src/components/Cards/Call4ImpactCard/container/index.js